import * as I from 'immutable';
import React from 'react';

import {useOverlays} from 'app/components/Library/OverlaysProvider';
import {ApiOrganization, ApiOrganizationUser} from 'app/modules/Remote/Organization';
import {LoggedInUserActions} from 'app/providers/AuthProvider';

import {useManageFeatures} from './ManageFeaturesProvider';
import ManageFeaturesView from './ManageFeaturesView';

export interface Props {
  organization: I.ImmutableOf<ApiOrganization>;
  profile: I.ImmutableOf<ApiOrganizationUser>;
  loggedInUserActions: LoggedInUserActions;
}

const ManageFeaturesOverlay: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  organization,
  profile,
  loggedInUserActions,
}) => {
  const {manageFeaturesState, manageFeaturesActions, loading} = useManageFeatures();
  const {overlays} = useOverlays();

  const overlayNames = overlays.size > 0 ? overlays.map((o) => o!.get('name')).toArray() : [];

  return (
    <ManageFeaturesView
      profile={profile}
      organization={organization}
      loggedInUserActions={loggedInUserActions}
      manageFeaturesState={manageFeaturesState}
      manageFeaturesActions={manageFeaturesActions}
      mode={'overlay'}
      loading={loading}
      overlayNames={overlayNames}
      firebaseToken={null}
    />
  );
};

export default ManageFeaturesOverlay;
